import { Button } from '@e2n/ui';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import {
  faArrowDownShortWide,
  faArrowUpShortWide,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views.ts';

export function SortierungButton({ view }: { view: View }) {
  const { t } = useTranslation();
  const {
    store: { ui, setUebersichtSortierung, setKalenderSortierung },
  } = useRotationsplanFeatureContext();

  const istSortierungAufsteigend =
    view === 'planung'
      ? ui.kalender.istSortierungAufsteigend
      : ui.uebersicht.istSortierungAufsteigend;

  const setSortierung =
    view === 'planung' ? setKalenderSortierung : setUebersichtSortierung;

  function changeSortierung() {
    setSortierung(!istSortierungAufsteigend);
  }

  return (
    <Button
      className="flex items-center gap-2 w-fit"
      variant="ghost"
      onClick={changeSortierung}>
      <FontAwesomeIcon
        icon={
          istSortierungAufsteigend ? faArrowDownShortWide : faArrowUpShortWide
        }
      />
      <div className="hidden md:flex">
        {t('domain.mitarbeiter.rotationsplan.sortierung')}
      </div>
    </Button>
  );
}
